import { getVocabulary } from "components/Vocabulary";
import { compact } from "lodash";
import { Key } from "react";
import { BASE_SEVERITIES } from "views/Findings/constants/severity";

import { RiskRatingKeys } from "./riskScoreUtil";

export function displayTextWidth({
  text,
  font = "13px InterVariable",
  offset = 0,
}: {
  text: string;
  font?: string;
  offset?: number;
}) {
  const canvas = document.createElement("canvas");
  const context = canvas.getContext("2d");
  context!.font = font;
  const metrics = context?.measureText(text);
  return (metrics?.width ?? 0) + offset;
}

export function getVocabularyColumnWidth(
  key: Key | undefined,
  offset: number | undefined = 60,
) {
  if (["riskRating", "severity"].includes(key as string)) {
    const columnKeys = key === "riskRating" ? RiskRatingKeys : BASE_SEVERITIES;
    return Math.max(
      ...columnKeys.map((text) =>
        displayTextWidth({ text: getVocabulary(text), offset }),
      ),
    );
  }
  return undefined;
}

// to compute new copy name if name already exists
// input "abc", if exists then return "abc Copy". If "abc Copy" also exists, return "abc Copy 1" and so on
export const computeDuplicateName = (value: string, values: string[]) => {
  let counter = 0;
  let newValue = value;
  while (values.includes(newValue) && counter < newValue.length) {
    newValue = compact([value, "Copy", counter]).join(" ");
    counter++;
  }
  return newValue;
};
